import Splide from "@splidejs/splide";

function init() {

	bookingCarousel();

	var itemsCarousels = document.querySelectorAll(".items-carousel"),
		container = document.querySelector('.container'),
		marginLeft = '0px';

		if(container){
			var style = container.currentStyle || window.getComputedStyle(container);

			marginLeft = style.marginLeft ? style.marginLeft : '0px';
		}

		marginLeft = marginLeft != '0px' ? marginLeft : '1rem';

	if (itemsCarousels.length > 0) {
		window.utils.forEach(itemsCarousels, function (index, itemCarousels) {
			var carousel = new Splide(itemCarousels, {
				perPage: 3,
				perMove: 1,
				gap: '2rem',
				updateOnMove: true,
				arrows: false,
				autoplay: false,
				pauseOnHover: true,
				speed: 2000,
				drag: true,
				padding: { left: '0', right: marginLeft },
				trimSpace: false,
				pagination: true,
				omitEnd: true,
				arrowPath:
					"M40,20C40,8.97,31.03,0,20,0S0,8.97,0,20s8.97,20,20,20,20-8.97,20-20Zm-37.67,0C2.33,10.25,10.25,2.33,20,2.33s17.67,7.93,17.67,17.67-7.93,17.67-17.67,17.67S2.33,29.75,2.33,20ZM30.93,20.75h0c.4-.4.4-1.09,0-1.49l-8.63-8.63c-.41-.41-1.08-.41-1.49,0-.2.2-.31.46-.31.74h0c0,.28.11.55.31.74l6.83,6.84H9.15c-.58,0-1.05.47-1.05,1.05s.47,1.05,1.05,1.05h18.5l-6.83,6.84c-.4.4-.4,1.09,0,1.49.2.2.46.31.74.31s.55-.11.74-.31l8.63-8.63Z",
				classes: {
					// Add classes for arrows.
					arrows: "smx-navigation",
					arrow: "smx-nav",
					prev: "prev carousel-prev",
					next: "next carousel-next",
					pagination: "smx-pagination",
					page: "smx-dot",
				},
				breakpoints: {
					1550: {
						perPage: 3,
						padding: { left: '0', right: '15rem' },
					},
					1200: {
						perPage: 3,
						padding: { left: '0', right: '15rem' },
					},
					992: {
						perPage: 2,
						padding: { left: '0', right: '10rem' },
					},
					768: {
						perPage: 2,
						padding: { left: '0', right: '8rem' },
					},
					576: {
						perPage: 1,
						padding: { left: '0', right: '10rem' },
					},
				},
			});

			carousel.mount();
		});
	}
}

function bookingCarousel(){
	var bookingCarousels = document.querySelectorAll(".booking-carousel"),
		container = document.querySelector('.container'),
		marginLeft = '0px';

		if(container){
			var style = container.currentStyle || window.getComputedStyle(container);

			marginLeft = style.marginLeft ? style.marginLeft : '0px';
		}

		marginLeft = marginLeft != '0px' ? marginLeft : '1rem';

	if (bookingCarousels.length > 0) {
		window.utils.forEach(bookingCarousels, function (index, bookingCarousel) {
			var carousel = new Splide(bookingCarousel, {
				perPage: 5,
				perMove: 1,
				gap: '1rem',
				updateOnMove: true,
				arrows: false,
				autoplay: false,
				pauseOnHover: true,
				speed: 2000,
				drag: true,
				padding: { left: '0', right: marginLeft },
				trimSpace: false,
				pagination: false,
				omitEnd: true,
				arrowPath:
					"M40,20C40,8.97,31.03,0,20,0S0,8.97,0,20s8.97,20,20,20,20-8.97,20-20Zm-37.67,0C2.33,10.25,10.25,2.33,20,2.33s17.67,7.93,17.67,17.67-7.93,17.67-17.67,17.67S2.33,29.75,2.33,20ZM30.93,20.75h0c.4-.4.4-1.09,0-1.49l-8.63-8.63c-.41-.41-1.08-.41-1.49,0-.2.2-.31.46-.31.74h0c0,.28.11.55.31.74l6.83,6.84H9.15c-.58,0-1.05.47-1.05,1.05s.47,1.05,1.05,1.05h18.5l-6.83,6.84c-.4.4-.4,1.09,0,1.49.2.2.46.31.74.31s.55-.11.74-.31l8.63-8.63Z",
				classes: {
					// Add classes for arrows.
					arrows: "smx-navigation",
					arrow: "smx-nav",
					prev: "prev carousel-prev",
					next: "next carousel-next",
					pagination: "smx-pagination",
					page: "smx-dot",
				},
				breakpoints: {
					1550: {
						perPage: 4,
						padding: { left: '0', right: '15rem' },
					},
					1200: {
						perPage: 4,
						padding: { left: '0', right: '15rem' },
					},
					992: {
						perPage: 3,
						padding: { left: '0', right: '10rem' },
					},
					768: {
						perPage: 2,
						padding: { left: '0', right: '8rem' },
					},
					576: {
						perPage: 1,
						padding: { left: '0', right: '10rem' },
					},
				},
			});

			carousel.mount();

			// LOGICA PER FOCUS E CAMBIO SLIDE IN BASE A RADIO BUTTON
			const radioButtons = bookingCarousel.querySelectorAll('input[type="radio"]');

			radioButtons.forEach(function (radio) {
				function goToRadioSlide() {
					const slide = radio.closest('.splide__slide');

					if (slide) {
						const slides = slide.parentElement.children;
						const index = Array.prototype.indexOf.call(slides, slide);
						carousel.go(index);
					}
				}

				radio.addEventListener('focus', goToRadioSlide);
				radio.addEventListener('change', function () {
					if (radio.checked) {
						goToRadioSlide();
					}
				});
			});
		});
	}
}

export default { init };
